export default [
  {
    path: '/startup',
    name: 'Startup',
    component: () => import(/* webpackChunkName: "startup" */ './components/views/Startup.vue')
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import(/* webpackChunkName: "users" */ './components/views/Users.vue')
  }
]